module.exports = __webpack_public_path__ + "img/slideshow_2.b6773048.jpg";